import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';
import { OrigemMultiselectComponent } from './origem-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        OrigemMultiselectComponent
    ],
    exports: [
        OrigemMultiselectComponent
    ]
})
export class OrigemMultiselectModule { }
